import useInterval from "@use-it/interval";
import {
  Button,
  ButtonType,
  Dialog,
  Result,
  MessageBox,
  MessageBoxStatus,
} from "@yy/tofu-ui-react";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { closeModal, ModalRoutes } from "./ModalSwitch";
import fetcher, { paths } from "../../lib/fetcher";
import { OrderStatusResult } from "../../models/OrderStatusResult";
import qs from "qs";
import { HTTPService } from "../../lib/util";

const CheckOrderStatusModal = () => {
  const history = useHistory();
  const location = useLocation();
  const { orderId } = qs.parse(location.search, { ignoreQueryPrefix: true });

  const checkOrderStatus = async (isFinalCheck?: Boolean) => {
    const { data, code } = (await fetcher.get(paths.orderStatus, {
      id: orderId,
    })) as OrderStatusResult;

    if (code === HTTPService.Ok && data && data.status === 1) {
      // 跳转去支付成功弹窗
      history.push({
        pathname: ModalRoutes.PaySuccess,
        search: qs.stringify(
          {
            balance: data.yy_cash_pledge,
            paymentAmount: data.amount,
          },
          { addQueryPrefix: true }
        ),
      });
    } else {
      // 如果是手动检查（最后一次检查）
      if (isFinalCheck) {
        MessageBox({
          width: "324px",
          title: "",
          status: MessageBoxStatus.WARN,
          showOk: false,
          cancelTxt: "确认",
          desc: "暂无检测到您的支付结果",
        });
        history.push(ModalRoutes.Root);
      }
    }
  };

  useInterval(checkOrderStatus, 500);

  return (
    <Dialog
      active
      title=""
      showConfirmBtn={false}
      showCancelBtn={false}
      wrapperStyle={{ width: 562 }}
      className="check-order-status-dialog"
      onCancel={closeModal(history)}
    >
      <Result
        title="缴纳保证金"
        subTitle={
          <>
            <span>支付完成前请不要关闭此窗口。</span>
            <br />
            <span>请在新打开的支付宝支付页面完成支付！</span>
          </>
        }
      >
        <Button type={ButtonType.Emphasis} onClick={() => checkOrderStatus(true)}>
          已完成支付
        </Button>
      </Result>
    </Dialog>
  );
};

export default CheckOrderStatusModal;
